import {
  GET_SUPPLY_DETAILS,
  SEARCH_OPERATOR,
  UPDATE_FREIGHT_DETAILS,
  CREATE_CONSIGNMENT,
  UPDATE_CONSIGNMENT,
  CLEAR_FLAGS,
  GET_PHONE_NO,
} from './actions';
import { REQUEST, SUCCESS } from 'utils/actionGenerator';
import _get from 'lodash/get';

const defaultState = {};

export default function (state = defaultState, action) {
  switch (action.type) {
    case GET_SUPPLY_DETAILS[SUCCESS]:
      return { ...state, supplyDetails: action.response.data };
    case SEARCH_OPERATOR[SUCCESS]:
      return { ...state, opSearchResults: action.response.data };
    case UPDATE_FREIGHT_DETAILS[REQUEST]:
      return { ...state, freightDetailsUpdated: false };
    case UPDATE_FREIGHT_DETAILS[SUCCESS]:
      return { ...state, freightDetailsUpdated: true };
    case CREATE_CONSIGNMENT[REQUEST]:
      return { ...state, consignmentCreated: false };
    case CREATE_CONSIGNMENT[SUCCESS]:
      return { ...state, consignmentCreated: true };
    case UPDATE_CONSIGNMENT[REQUEST]:
      return { ...state, consignmentUpdated: false };
    case UPDATE_CONSIGNMENT[SUCCESS]:
      return { ...state, consignmentUpdated: true };
    case GET_PHONE_NO[REQUEST]:
      return { ...state, phoneNo: '' };
    case GET_PHONE_NO[SUCCESS]:
      return { ...state, phoneNo: action.response };
    // case GET_PHONE_NO[FAILURE]:
    //   return { ...state, phoneNo: '' };
    case CLEAR_FLAGS:
      return {
        ...state,
        consignmentUpdated: false,
        consignmentCreated: false,
        freightDetailsUpdated: false,
      };
    default:
      return state;
  }
}

// export const getDemandTabReducer = (state) => state.demandTab;

export const getSupplyDetails = (state) => _get(state, 'placement.supplyTab.supplyDetails', {});
export const getOpSearchResults = (state) => _get(state, 'placement.supplyTab.opSearchResults', {});
export const getFreightDetailsUpdateFlag = (state) => _get(state, 'placement.supplyTab.freightDetailsUpdated', false);
export const getConsignmentCreatedFlag = (state) => _get(state, 'placement.supplyTab.consignmentCreated', false);
export const getConsignmentUpdatedFlag = (state) => _get(state, 'placement.supplyTab.consignmentUpdated', false);
export const getPhoneNo = (state) => _get(state, 'placement.supplyTab.phoneNo', '');

